<form
  class="edit-form"
  *ngIf="!isLoading && clients"
  [formGroup]="editForm"
  (submit)="onSubmit()"
>
  <mat-form-field>
    <mat-label>{{ "repository.sites.edit.name.label" | translate }}</mat-label>
    <input type="text" matInput formControlName="name" />
    <mat-error>{{
      "repository.sites.edit.name.errorMessage" | translate
    }}</mat-error>
  </mat-form-field>

  <app-multi-select-list
    formControlName="clients"
    [allItems]="clients"
    label="repository.sites.edit.client.label"
    title="Agences"
  >
  </app-multi-select-list>

  <mat-checkbox *ngIf="site && site.otherSite" formControlName="otherSite">{{
    "repository.sites.edit.otherSite.label" | translate
  }}</mat-checkbox>

  <fieldset class="allow-other-address-field">
    <legend>
      {{ "repository.sites.edit.allowOtherAddress.label" | translate }}
      <mat-icon
        class="allow-other-address-info"
        [matTooltip]="
          'repository.sites.edit.allowOtherAddress.tooltip' | translate
        "
        [attr.aria-label]="
          'repository.sites.edit.allowOtherAddress.tooltip' | translate
        "
        >info_outline</mat-icon
      >
    </legend>
    <mat-radio-group formControlName="allowOtherAddress">
      <mat-radio-button [value]="true">{{
        "repository.sites.edit.allowOtherAddress.yes" | translate
      }}</mat-radio-button>
      <mat-radio-button [value]="false">{{
        "repository.sites.edit.allowOtherAddress.no" | translate
      }}</mat-radio-button>
      <mat-radio-button [value]="null">{{
        "repository.sites.edit.allowOtherAddress.inherited" | translate
      }}</mat-radio-button>
    </mat-radio-group>
  </fieldset>

  <mat-checkbox formControlName="transmissionOnly">{{
    "repository.sites.edit.transmissionOnly.label" | translate
  }}</mat-checkbox>

  <fieldset class="default-address-field" *ngIf="editForm.get('address')">
    <legend>
      {{ "repository.sites.edit.defaultAddress.label" | translate }}
      <mat-icon
        class="allow-other-address-info"
        [matTooltip]="'repository.sites.edit.defaultAddress.tooltip' | translate"
        [attr.aria-label]="
          'repository.sites.edit.defaultAddress.tooltip' | translate
        "
        >info_outline</mat-icon
      >
    </legend>
    <mat-form-field>
      <mat-label>{{
        "repository.sites.edit.defaultAddress.label" | translate
      }}</mat-label>
      <mat-select formControlName="address" [compareWith]="compareAddresses">
        <mat-option [value]="null">{{
          "repository.sites.edit.defaultAddress.none" | translate
        }}</mat-option>
        <mat-option
          *ngFor="let address of senderAddresses"
          [value]="address"
          >{{ address.display }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </fieldset>

  <mat-form-field>
    <mat-label>{{
      "repository.sites.edit.documentUrl.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="documentUrl" />
    <mat-error>{{
      "repository.sites.edit.name.errorMessage" | translate
    }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Siren</mat-label>
    <input type="text" matInput formControlName="siren" />
    <mat-error>Le numéro SIREN doit contenir 9 chiffres.</mat-error>
  </mat-form-field>

  <app-validate-and-cancel
    (submitEvent)="endForm($event)"
    [editForm]="editForm"
    [disabling]="editForm.invalid"
  ></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
